export default __webpack_public_path__ + "static/media/04.22b86079.jpg";